import React from 'react';
import { Eye, ListChecks, Zap } from 'lucide-react';
export function SolutionSection() {
  const steps = [{
    number: '01',
    icon: <Eye className="w-5 h-5 sm:w-6 sm:h-6 text-black" data-id="element-488" />,
    title: 'Sistema visual',
    description: 'Convierte tu tarea en micro-pasos visibles. No improvisas. Ejecutas lo que ya está mapeado.'
  }, {
    number: '02',
    icon: <ListChecks className="w-5 h-5 sm:w-6 sm:h-6 text-black" data-id="element-489" />,
    title: 'Timer',
    description: '25/5 para alta interrupción. 52/17 para producción real. El tiempo se protege, no se negocia.'
  }, {
    number: '03',
    icon: <Zap className="w-5 h-5 sm:w-6 sm:h-6 text-black" data-id="element-490" />,
    title: 'Lista corta',
    description: '1 bloque. 1 tarea. 1 cierre. No necesitas controlar un día perfecto. Necesitas un bloque repetible.'
  }];
  return <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-dark-800 relative" data-id="element-491">
      <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-492">
        <div className="text-center mb-10 sm:mb-12 md:mb-16" data-id="element-493">
          <div className="inline-block bg-gold-500/10 border border-gold-500/30 rounded-full px-4 py-1.5 sm:px-6 sm:py-2 mb-4 sm:mb-6" data-id="element-494">
            <span className="text-gold-500 font-bold uppercase tracking-wider text-xs sm:text-sm" data-id="element-495">
              La Solución
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6 leading-tight px-4" data-id="element-496">
            <span className="text-white" data-id="element-497">El </span>
            <span className="text-gradient-gold font-serif italic" data-id="element-498">
              MÉTODO CIERRE 90'
            </span>
          </h2>
          <p className="text-xl sm:text-2xl text-gray-300 font-light mb-3 sm:mb-4" data-id="element-499">
            1 bloque · 1 tarea · 1 cierre
          </p>
          <p className="text-base sm:text-lg text-gray-400 max-w-2xl mx-auto mb-4 px-4 leading-relaxed" data-id="element-500">
            Este sistema está diseñado para reducir la saturación mental,
            mejorar el enfoque y cerrar tareas importantes{' '}
            <span className="text-gold-500 font-semibold" data-id="element-501">
              sin forzar tu energía ni vivir en modo agotamiento
            </span>
            .
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-12 items-center mb-12 sm:mb-16" data-id="element-502">
          {/* Image showing the method in action */}
          <div className="order-2 lg:order-1" data-id="element-503">
            <div className="relative rounded-xl sm:rounded-2xl overflow-hidden border border-gold-500/20 shadow-2xl" data-id="element-504">
              <img src="https://cdn.magicpatterns.com/uploads/aAXMaX4afaDWnLKC14PvPu/4_Focused_and_focused_in_the_city.png" alt="Profesional enfocado con el Método CIERRE 90" className="w-full h-auto" data-id="element-505" />
            </div>
          </div>

          {/* Steps */}
          <div className="order-1 lg:order-2 space-y-6 sm:space-y-8" data-id="element-506">
            {steps.map((step, index) => <div key={index} className="relative group" data-id="element-507">
                <div className="bg-dark-900 p-4 sm:p-6 rounded-xl sm:rounded-2xl border border-white/5 hover:border-gold-500/30 transition-all duration-300" data-id="element-508">
                  <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-4" data-id="element-509">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gold-500 rounded-full flex items-center justify-center z-10 relative group-hover:scale-110 transition-transform duration-300 shadow-[0_0_15px_rgba(212,175,55,0.4)] flex-shrink-0" data-id="element-510">
                      {step.icon}
                    </div>
                    <span className="text-gold-500/50 font-serif text-2xl sm:text-3xl font-bold" data-id="element-511">
                      {step.number}
                    </span>
                  </div>
                  <h3 className="text-xl sm:text-2xl font-bold text-white mb-2 sm:mb-3" data-id="element-512">
                    {step.title}
                  </h3>
                  <p className="text-sm sm:text-base text-gray-400 leading-relaxed" data-id="element-513">
                    {step.description}
                  </p>
                </div>
                {index !== steps.length - 1 && <div className="absolute left-5 sm:left-6 top-full w-px h-6 sm:h-8 bg-gold-500/20" data-id="element-514"></div>}
              </div>)}
          </div>
        </div>

        <div className="bg-gradient-to-r from-gold-500/10 via-gold-500/5 to-gold-500/10 border border-gold-500/20 rounded-xl sm:rounded-2xl p-6 sm:p-8 md:p-12 text-center" data-id="element-515">
          <p className="text-xl sm:text-2xl md:text-3xl font-serif italic text-white mb-3 sm:mb-4 leading-relaxed" data-id="element-516">
            "Menos estrés no por relajarte...
          </p>
          <p className="text-2xl sm:text-3xl md:text-4xl font-serif font-bold text-gradient-gold leading-tight" data-id="element-517">
            sino por cerrar."
          </p>
          <p className="text-gray-400 mt-4 sm:mt-6 text-base sm:text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-518">
            Si no hay cierres, hay ruido mental. Si hay cierre, el ruido baja.
          </p>
        </div>
      </div>
    </section>;
}